import script from "./ToplistCounties.vue?vue&type=script&setup=true&lang=js"
export * from "./ToplistCounties.vue?vue&type=script&setup=true&lang=js"

import "./ToplistCounties.vue?vue&type=style&index=0&id=70bec2e4&scoped=true&lang=css"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-70bec2e4"]])

export default __exports__